import { FC, useContext } from 'react';

import { Confirmation } from '../../../../../../shared/components';

interface ConfirmationEndorsementsProps {
    description?: string;
    onconfirm?: () => void;
}

export const ConfirmationEndorsements: FC<ConfirmationEndorsementsProps> = ({description, onconfirm}) => {
  return (
    <Confirmation
      title={'Confirmado'}
      onPressConfirm={ onconfirm }
      description={description}
    />
  );
};
